<template>
    <BCard v-if="movement" >
        <ValidationObserver ref="form" #default="{ invalid }">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <VSelectValidated v-if="movement_types" vsName="Movement type" :vsModel.sync="movement.movement_type_id" :vsOptions="movement_types" :vsReduce="type=>type.id" vsMd="6" vsLabel="name" vsRequired vsRules="required" />
                    <NumberInputValidated vsName="Amount" :vsModel.sync="movement.amount" vsMd="6" vsRequired vsRules="required"/>

                    <DatepickerValidated vsName="Emit date" :vsModel.sync="movement.emit_date" vsRequired vsRules="required" vsMd="6" />

                    <VSelectValidated v-if="cashes" vsName="Caja" :vsModel.sync="movement.cash_register_id" :vsOptions="cashes" :vsReduce="cash=>cash.id" vsMd="6" vsLabel="name" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Observations" :vsModel.sync="movement.observations" vsLabel="observations" vsMd="6" vsRequired vsRules="required" />


                </BRow>
                <BButton variant="primary" class="mt-3 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                <BButton variant="outline-secondary" class="mt-3" type="reset" :to="{ name:'cash' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { BButton, BCard, BForm, BRow } from 'bootstrap-vue';
import { ValidationObserver } from 'vee-validate';
import { onUnmounted, ref } from '@vue/composition-api';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import VSelectValidated from '@/components/forms/vSelectValidated.vue';
import popups from '@/hooks/popups';
import router from '@/router';
import store from '@/store';
import axios from '@axios'


export default {
    components: { BCard, ValidationObserver, BForm, BRow, TextInputValidated, NumberInputValidated,  DatepickerValidated, VSelectValidated, BButton },
    setup(){
        const { errorToast } = popups()
        const groups = ref([])
        const cash = ref(null)
        const movement_types=ref(null)
        const cashes=ref(null)
        const movement=ref(null)

        axios.get("types").then((r) => {
            movement_types.value=r.data.movement_types
        })

        axios.get("cashes").then((r) => {
            cashes.value=r.data.cashes
        })


        axios.get(`movements/${router.currentRoute.params.id}`)
            .then(response => {movement.value=response.data.movement;})

        const onSubmit = function(){
            this.$refs.form.validate().then(success => {
                if(success){
                    axios.put(`movements/${router.currentRoute.params.id}`, JSON.parse(JSON.stringify(movement.value)))
                        .then(response => {
                                if (response.data.success) {
                                    this.$router.push({ name: 'cash-selector' })
                                }
                            })
                        .catch(error => { errorToast('Can\'t add cash') })
                }
            })
        }

      

        return {
            onSubmit,
            groups,
            cash, 
            movement_types, 
            cashes, 
            movement
        }
    }
}
</script>